import React from "react";

const AboutStory = () => {
  return (
    <section className="bg-white py-20 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16">
        {/* Left Content */}
        <div className="lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-8">
            Our Story
          </h2>
          <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
            <p>
              Since 1996, Hirapanna Jewellers has been at the forefront of fine jewelry
              craftsmanship in North Bihar. Our journey began when our forefathers
              migrated from Hajipur to Muzaffarpur, bringing with them generations of
              goldsmithing expertise.
            </p>
            <p>
              What started as a small artisan workshop has evolved into one of
              the region's most trusted names in luxury jewelry. We specialize in
              exquisite gold, as well as premium silver and certified diamond collections.
            </p>
            <p>
              Every piece we create tells a story—from everyday elegance to once-in-a-lifetime
              celebrations. Our commitment to 100% hallmarked gold,
              certified diamonds, and transparent pricing has made us the preferred
              choice for discerning customers across generations.
            </p>
          </div>
        </div>

        {/* Right Image */}
        <div className="lg:w-1/2 relative">
          <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl">
            <img 
              src="/about/workshop_bw.png" 
              alt="Traditional Jewelry Workshop" 
              className="w-full h-auto grayscale hover:grayscale-0 transition-all duration-700"
            />
          </div>
          {/* Floating Gold Box */}
          <div className="absolute -bottom-8 -left-8 z-20 bg-[#D4AF37] p-8 shadow-xl max-w-[200px]">
            <h3 className="text-4xl font-serif text-white mb-1">28+</h3>
            <p className="text-white text-sm uppercase tracking-widest font-medium">Years of Excellence</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
